<div class="map-model">
  <h2 mat-dialog-title class="mat-h2">
    Sample Details
    <button mat-icon-button class="close-button" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>
  <mat-dialog-content >
    <div class="header-row">
      <h1 class="mat-h1">{{ cityName }}</h1>
    </div>
    <div class="content" [class.split]="!toggleValue">
      @if (!toggleValue) {
        <aside class="inputs">
          <div class="section-header-row">
            <h3 class="mat-subtitle-1">Search by Location</h3>
            <mat-slide-toggle
              [checked]="toggleValue"
              [disabled]="!(selectedSoilCategory && selectedDensity && selectedMoisture)"
              (change)="onToggleChange($event)"
              >
              {{ toggleValue ? 'Individual File' : 'Average Data' }}
            </mat-slide-toggle>
          </div>
          <mat-form-field style="width: 100%;" appearance="outline">
            <mat-icon matPrefix>search</mat-icon>
            <input
              #soilCtrlAutocompleteInput
              type="text"
              placeholder="Select Soil Type"
              matInput
              [formControl]="soilCtrl"
              [matAutocomplete]="auto1"
              (input)="filterSoilCategories()"
              (focus)="filterSoilCategories()"
              (blur)="validateSoilSelection()"
              />
              <mat-autocomplete #auto1="matAutocomplete" requireSelection (optionSelected)="onSoilSelected()">
                @for (soil of filteredSoils; track soil) {
                  <mat-option [value]="soil">{{ soil }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <mat-form-field style="width: 100%;" appearance="outline">
              <mat-icon matPrefix>search</mat-icon>
              <input
                #densityCtrlAutocompleteInput
                type="text"
                placeholder="Select Density"
                matInput
                [formControl]="densityCtrl"
                [matAutocomplete]="densityAuto1"
                (input)="filterDensities()"
                (focus)="filterDensities()"
                (blur)="validateDensitySelection()"
                />
                <mat-autocomplete #densityAuto1="matAutocomplete" requireSelection (optionSelected)="onDensitySelected()">
                  <mat-option value="All">All</mat-option>
                  @for (d of filteredDensities; track d) {
                    <mat-option [value]="d">{{ d }}</mat-option>
                  }
                </mat-autocomplete>
              </mat-form-field>
              <!-- MOISTURE (location) -->
              <mat-form-field style="width: 100%;" appearance="outline">
                <mat-icon matPrefix>search</mat-icon>
                <input
                  #moistureCtrlAutocompleteInput
                  type="text"
                  placeholder="Select Moisture"
                  matInput
                  [formControl]="moistureCtrl"
                  [matAutocomplete]="moistureAuto1"
                  (input)="filterMoistures()"
                  (focus)="filterMoistures()"
                  (blur)="validateMoistureSelection()"
                  />
                  <mat-autocomplete #moistureAuto1="matAutocomplete" requireSelection (optionSelected)="onMoistureSelected()">
                    <mat-option value="All">All</mat-option>
                    @for (m of filteredMoistures; track m) {
                      <mat-option [value]="m">{{ m }}</mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
                <mat-divider class="my-3"></mat-divider>
                <h3 class="mat-subtitle-1">Search by Project File</h3>
                <mat-form-field style="width: 100%;" appearance="outline">
                  <mat-icon matPrefix>folder</mat-icon>
                  <input
                    #projectCtrlAutocompleteInput
                    type="text"
                    placeholder="Select Project File"
                    matInput
                    [formControl]="projectCtrl"
                    [matAutocomplete]="projectAuto"
                    (input)="filterProjects()"
                    (focus)="filterProjects()"
                    (blur)="validateProjectSelection()"
                    />
                    <mat-autocomplete #projectAuto="matAutocomplete" requireSelection (optionSelected)="onProjectSelected()">
                      @for (p of filteredProjects; track p) {
                        <mat-option [value]="p">{{ p }}</mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                  <mat-form-field style="width: 100%;" appearance="outline">
                    <mat-icon matPrefix>search</mat-icon>
                    <input
                      #projectSoilCtrlAutocompleteInput
                      type="text"
                      placeholder="Select Soil Type"
                      matInput
                      [formControl]="projectSoilCtrl"
                      [matAutocomplete]="auto2"
                      (input)="filterProjectSoils()"
                      (focus)="filterProjectSoils()"
                      (blur)="validateProjectSoilSelection()"
                      />
                      <mat-autocomplete #auto2="matAutocomplete" requireSelection (optionSelected)="onProjectSoilSelected()">
                        <mat-option value="All">All</mat-option>
                        @for (soil of filteredProjectSoils; track soil) {
                          <mat-option [value]="soil">{{ soil }}</mat-option>
                        }
                      </mat-autocomplete>
                    </mat-form-field>
                    <mat-form-field style="width: 100%;" appearance="outline">
                      <mat-icon matPrefix>search</mat-icon>
                      <input
                        #projectDensityCtrlAutocompleteInput
                        type="text"
                        placeholder="Select Density"
                        matInput
                        [formControl]="projectDensityCtrl"
                        [matAutocomplete]="densityAuto2"
                        (input)="filterProjectDensities()"
                        (focus)="filterProjectDensities()"
                        (blur)="validateProjectDensitySelection()"
                        />
                        <mat-autocomplete #densityAuto2="matAutocomplete" requireSelection (optionSelected)="onProjectDensitySelected()">
                          <mat-option value="All">All</mat-option>
                          @for (d of filteredProjectDensities; track d) {
                            <mat-option [value]="d">{{ d }}</mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>
                      <mat-form-field style="width: 100%;" appearance="outline">
                        <mat-icon matPrefix>search</mat-icon>
                        <input
                          #projectMoistureCtrlAutocompleteInput
                          type="text"
                          placeholder="Select Moisture"
                          matInput
                          [formControl]="projectMoistureCtrl"
                          [matAutocomplete]="moistureAuto2"
                          (input)="filterProjectMoistures()"
                          (focus)="filterProjectMoistures()"
                          (blur)="validateProjectMoistureSelection()"
                          />
                          <mat-autocomplete #moistureAuto2="matAutocomplete" requireSelection (optionSelected)="onProjectMoistureSelected()">
                            <mat-option value="All">All</mat-option>
                            @for (m of filteredProjectMoistures; track m) {
                              <mat-option [value]="m">{{ m }}</mat-option>
                            }
                          </mat-autocomplete>
                        </mat-form-field>
                      </aside>
                    }
                    <section class="graph">
                      @if (toggleValue) {
                        <mat-slide-toggle
                          [checked]="toggleValue"
                          [disabled]="!(selectedSoilCategory && selectedDensity && selectedMoisture)"
                          (change)="onToggleChange($event)"
                          >
                          {{ toggleValue ? 'Individual File' : 'Average Data' }}
                        </mat-slide-toggle>
                      }
                      @if (detectRedraw) {
                        <app-line-chart
                          [xMax]="xMax"
                          [yMax]="yMax"
                          [lineChartData]="lineChartData"
                        ></app-line-chart>
                      }
                      <div class="stats under-graph">
                        <div class="stat">
                          <span class="label">Average Density</span>
                          <span class="chip">{{ dryDensityAvg | number:'1.0-2' }} lb/ft³</span>
                        </div>
                        <div class="stat">
                          <span class="label">Average Moisture</span>
                          <span class="chip">{{ moistureAvg | number:'1.0-2' }} %</span>
                        </div>
                      </div>
                    </section>
                  </div>
                </mat-dialog-content>
              </div>
